const TimeUnitStringRegex = /^(\d+)(ms|s|m|h|d|w|y)$/;

/**
 * @description Convert a time unit string to milliseconds
 * @param timeUnit
 * @returns the time unit in milliseconds
 */
globalThis.timeUnitToMs = function timeUnitToMs(timeUnit) {
	const match = timeUnit.match(TimeUnitStringRegex);
	if (match === null) {
		throw new Error(`Invalid time unit string: ${timeUnit}`);
	}
	const time = parseInt(match[1], 10);
	const unit = match[2];
	switch (unit) {
		case 'ms':
			return time;
		case 's':
			return time * 1000;
		case 'm':
			return time * 60 * 1000;
		case 'h':
			return time * 60 * 60 * 1000;
		case 'd':
			return time * 24 * 60 * 60 * 1000;
		case 'w':
			return time * 7 * 24 * 60 * 60 * 1000;
		case 'y':
			return time * 365 * 24 * 60 * 60 * 1000;
	}
	return NaN;
};

export {};
